import React, { FC, useEffect, useState } from 'react';
// import {
//   Box,
//   Button,
//   Card,
//   CardActions,
//   CardMedia,
//   CircularProgress,
//   Fab,
//   Grid,
// } from '@material-ui/core';
// import { Add } from '@material-ui/icons';
import moment from 'moment';
import { Box, Button, Card, CardFooter, Grid, GridItem, IconButton, Spinner, Image, Heading } from '@chakra-ui/react';
import { MdAdd } from 'react-icons/md';

import { EquipmentsGuideFormInstance } from './types';
import { useEntityState } from '../../hooks/use-entity-state';
import TextField from '../common/text-field';
import SelectField from '../common/select-field';
import { ImageDescriptor } from '../../api/models/image';
import api from '../../api/api';
import GalleryModal from '../common/modals/gallery';
import NumberField from '../common/number-field';

interface EquipmentsGuideFormProps {
  instance: Partial<EquipmentsGuideFormInstance>;
  submitText?: string;
  onSubmit: (instance: Partial<EquipmentsGuideFormInstance>) => void;
  onCancel: () => void;
}

const YesNoOptions = [
  { id: 1, name: 'нет' },
  { id: 2, name: 'да' },
];

const EquipmentsGuideForm: FC<EquipmentsGuideFormProps> = (props) => {
  const { instance, submitText, onSubmit, onCancel } = props;

  const [images, setImages] = useState<ImageDescriptor[]>([]);
  const [equipModel, onChange, setInstance] =
    useEntityState<EquipmentsGuideFormInstance>(instance);
  const [removingImage, setRemovingImage] = useState<number>();

  const [loading, setLoading] = useState<boolean>(false);
  const [uploading, setUploading] = useState<boolean>(false);
  const [showGallery, setShowGallery] = useState<boolean>(false);
  const [galleryCurrentIndex, setGalleryCurrentIndex] = useState<number>(0);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    setInstance(instance);
    (async () => {
      if (!instance?.images) {
        return;
      }
      setLoading(true);
      const _images = await Promise.all(
        instance.images.map(async ({ image_pid, last_update }) => {
          try {
            const { data } = await api.file.get('' + image_pid);
            return {
              image_pid,
              last_update,
              src: 'data:image/jpeg;base64,' + data,
            };
          } catch (e) {
            return {
              image_pid,
              last_update,
            };
          }
        })
      );
      setImages(_images);
      setLoading(false);
    })();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onAddClick = () => {
    const input = document.createElement('input');
    input.type = 'file';
    input.click();
    input.onchange = (e: Event) => {
      setUploading(true);
      const file = (e.target as HTMLInputElement).files[0];
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = async function () {
        const { data } = await api.file.upload({
          images: [
            {
              filename: file.name,
              content: reader.result,
            },
          ],
          equip_model_id: Number(instance.id),
        });

        const imagePid = data.data.file_ids[0];
        setImages((images) => [
          ...images,
          {
            image_pid: imagePid,
            last_update: moment().format('YYYY-MM-DD'),
            src: reader.result.toString(),
          },
        ]);
        setUploading(false);
      };
      reader.onerror = function (e) {
        console.log(e);
      };
    };
  };

  const onDeleteClick = async (imagePid: number) => {
    setRemovingImage(imagePid);
    const response = await api.file.remove('' + imagePid);

    if (response.data.code === 200) {
      setImages((images) =>
        images.filter((item) => item.image_pid !== imagePid)
      );
    }

    setRemovingImage(undefined);
  };

  return (
    <>
      {equipModel.name && <Heading size='md' pb={4}>{equipModel.name}</Heading>}
      <Grid gap={5} templateColumns={{ base: '1fr', md: '1fr 1fr' }}>
        <GridItem colSpan={{ base: 1, md: 2 }}>
          <TextField
            id="description"
            label="Описание"
            multiline
            rows={4}
            value={equipModel.description}
            onChange={onChange('description')}
          />
        </GridItem>
        <GridItem >
          <NumberField
            label="Ширина, мм"
            id="width"
            value={equipModel.width || 0}
            onChange={onChange('width')}
          />
        </GridItem>

        <GridItem >
          <NumberField
            label="Высота, мм"
            id="height"
            value={equipModel.height || 0}
            onChange={onChange('height')}
          />
        </GridItem>

        <GridItem >
          <NumberField
            label="Глубина, мм"
            id="depth"
            value={equipModel.depth || 0}
            onChange={onChange('depth')}
          />
        </GridItem>

        <GridItem >
          <NumberField
            label='Занимаемая площадь пола, м³'
            id="volume_on_floor"
            value={equipModel.volume_on_floor || 0}
            onChange={onChange('volume_on_floor')}
          />
        </GridItem>

        <GridItem >
          <NumberField
            label="Внутренний объем, л"
            id="volume_inner"
            value={equipModel.volume_inner || 0}
            onChange={onChange('volume_inner')}
          />
        </GridItem>

        <GridItem >
          <NumberField
            label="Вес"
            id="weight"
            value={equipModel.weight || 0}
            onChange={onChange('weight')}
          />
        </GridItem>

        <GridItem >
          <NumberField
            label="Энергопотребление, кВт в сутки"
            id="consumption_energy"
            value={equipModel.consumption_energy || 0}
            onChange={onChange('consumption_energy')}
          />
        </GridItem>

        <GridItem >
          <TextField
            label="Хладагент"
            id="coolant"
            value={equipModel.coolant || ''}
            onChange={onChange('coolant')}
          />
        </GridItem>

        <GridItem >
          <TextField
            label="Материал внутреннего корпуса"
            id="material_inner"
            value={equipModel.material_inner || ''}
            onChange={onChange('material_inner')}
          />
        </GridItem>

        <GridItem >
          <TextField
            label="Количество полок"
            id="shelves"
            value={equipModel.shelves || ''}
            onChange={onChange('shelves')}
          />
        </GridItem>

        <GridItem >
          <SelectField
            label="Возможность использования на улице"
            value={
              equipModel.is_use_outdoor !== undefined
                ? equipModel.is_use_outdoor ? YesNoOptions[1] : YesNoOptions[0]
                : undefined
            }
            onChange={({ id }) =>
              onChange('is_use_outdoor')(!!(Number(id) - 1))
            }
            id=""
            name=""
            options={YesNoOptions}
          />
        </GridItem>

        <GridItem >
          <SelectField
            label="Возможность установки замка"
            value={
              equipModel.is_use_lock !== undefined
                ? equipModel.is_use_lock ? YesNoOptions[1] : YesNoOptions[0]
                : undefined
            }
            onChange={({ id }) => onChange('is_use_lock')(!!(Number(id) - 1))}
            id=""
            name=""
            options={YesNoOptions}
          />
        </GridItem>

        <GridItem >
          <SelectField
            label="Возможность установки обогрева"
            value={
              equipModel.is_adding_heater !== undefined
                ? equipModel.is_adding_heater ? YesNoOptions[1] : YesNoOptions[0]
                : undefined
            }
            onChange={({ id }) =>
              onChange('is_adding_heater')(!!(Number(id) - 1))
            }
            id=""
            name=""
            options={YesNoOptions}
          />
        </GridItem>

        <GridItem >
          <SelectField
            label="Активно"
            value={
              equipModel.is_visible !== undefined
                ? equipModel.is_visible ? YesNoOptions[1] : YesNoOptions[0]
                : undefined
            }
            onChange={({ id }) => onChange('is_visible')(!!(Number(id) - 1))}
            id=""
            name=""
            options={YesNoOptions}
          />  
        </GridItem>

        <GridItem colSpan={{ base: 1, md: 2 }}>
          <Grid 
            gap={5} 
            style={{ position: 'relative' }}
            templateColumns={{ base: '1fr', sm: '1fr 1fr', md: 'repeat(3, 1fr)', lg: 'repeat(6, 1fr)' }}
          >
            {loading && (
              <Box
                position="absolute"
                width="100%"
                height={200}
                display="flex"
                justifyContent="center"
                alignItems="center"
              >
                <Spinner />
              </Box>
            )}
            {images.map((image, index) => {
              return (
                <GridItem key={image.image_pid}>
                  <Card position='relative'>
                    {image.image_pid === removingImage && (
                      <Box
                        position="absolute"
                        width="100%"
                        height={200}
                        display="flex"
                        justifyContent="center"
                        alignItems="center"
                      >
                        <Spinner />
                      </Box>
                    )}
                    <Image
                      style={{ height: '200px', cursor: 'pointer' }}
                      src={image.src}
                      objectFit='cover'
                      onClick={() => {
                        setGalleryCurrentIndex(index);
                        setShowGallery(true);
                      }}
                    />
                    <CardFooter>
                      <Button
                        size="small"
                        color="primary"
                        onClick={() => onDeleteClick(image.image_pid)}
                      >
                        Удалить
                      </Button>
                    </CardFooter>
                  </Card>
                </GridItem>
              );
            })}
            <GridItem style={{ opacity: loading ? '0.3' : 1 }}>
              <Box
                minHeight={200}
                display="flex"
                justifyContent="center"
                alignItems="center"
                height="100%"
                borderRadius={8}
                border="dotted 1px #AAA"
                position="relative"
              >
                {uploading && (
                  <Box
                    position="absolute"
                    width="100%"
                    height={200}
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                  >
                    <Spinner />
                  </Box>
                )}
                {!uploading && (
                  <IconButton color="primary" aria-label="add" onClick={onAddClick}>
                    <MdAdd />
                  </IconButton>
                )}
              </Box>
            </GridItem>
          </Grid>
        </GridItem>
        <GridItem colSpan={{ base: 1, md: 2 }} mt={10}>
          <TextField
            id="comment"
            label="Комментарий"
            multiline
            rows={4}
            value={equipModel.comment}
            onChange={onChange('comment')}
          />
        </GridItem>
        <GridItem colSpan={{ base: 1, md: 2 }}>
          <Box display="flex" justifyContent="space-between">
            <Button
              colorScheme="brand"
              size="md"
              onClick={() => onSubmit({ ...equipModel })}
            >
              {submitText || 'Создать'}
            </Button>
            <Button
              variant="ghost"
              size="md"
              onClick={onCancel}
            >
              Отмена
            </Button>
          </Box>
        </GridItem>
      </Grid>
      <GalleryModal
        images={images}
        open={showGallery}
        onClose={() => setShowGallery(false)}
        title="Изображения"
        index={galleryCurrentIndex}
        icon={<div />}
      />
    </>
  );
};

export default EquipmentsGuideForm;
